<template>
  <!-- 目的国家和目的机场综合 -->
  <div class="inputSearch">
    <input type="text" class="inputSear" v-model="inputText" ref="ipt" :placeholder="setPlaceholder" :style="{width:setWidth,height:height,}" @focus="focusInput" @keydown="keydown($event)" @input="getInputVal(inputText)" @blur="blurInput" @click="RecentShow" />
    <div v-show="isShow != 3" class="dataBox" style="min-width:246px;" id="localInputSeacrh">
      <div v-show="isShow == 0">
        <div class="Recent"> My Records</div>
        <div style="text-align: center;padding: 5px;" v-show="!Recent.length">No result</div>
        <el-scrollbar style="height:100%;min-width: 246px">
          <ul v-show="Recent.length" style="max-height:200px">
            <li class="es  fontZero" v-for="(item,index) in Recent" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" @mouseover="clearKeydown(index)">
              <div class="left">
                <div class="left_text  es">
                  <span class="fa fa-Airfeiji"></span>
                  {{item.AirportCode3}}{{"("+item.AirportNameEn+")"}}
                </div>
              </div>
              <div class="right">
                <div class="right_text es">
                  {{item.CountryNameEn}}
                </div>
              </div>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <div v-show="isShow != 2">
        <div v-show="isShow !== 2" class="Recent"> Destination Airport</div>
        <el-scrollbar style="height:100%;">
          <ul style="max-height:300px" v-show="isShow !== 2">
            <li class="es fontZero" v-for="(item,index) in queryList" :key="index" @click="getText(item)" :class="{isActive:(isShow==0 ? Recent.length+index :index)==isIndex}" @mouseover="clearKeydownQuery(index)">
              <div class="left">
                <div class="left_text  es">
                  <span class="fa fa-Airfeiji"></span>
                  {{item.AirportCode3}}{{"("+item.AirportNameEn+")"}}
                </div>
              </div>
              <div class="right">
                <div class="right_text es">
                  {{item.CountryNameEn}}
                </div>
              </div>
            </li>
          </ul>
          <div v-show="!queryList.length" style="text-align: center;padding: 5px;">No result</div>
          <ul v-show="isShow == 2">
            <div class="Recent"> Destination Airport</div>
          </ul>
        </el-scrollbar>
      </div>
      <!-- 模糊搜索 end -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import bus from '@/ask/eventBus';
import { post, fetch, Del, put } from "@/ask/axios";
import { getCustomer } from "@/utils/getCustomer";
export default {
  props: {
    setPlaceholder: { type: String }, //输入框默认值
    setWidth: { type: String }, //宽度
    height: { type: String }, //高度
    Recent: { type: Array }, //最近列表
    setData: { type: Object }, // 设置属性
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      isShow: 3, //0是否显示最近查询 1:数据显示，2：数据无结果显示 3.不显示
      inputFocus: true, //聚焦
      inputText: '',//输入
      disappear: true,
      key: "",
      AllList: [],//所有列表
      queryList: [],
      isIndex: -1,
      curList: '',//当前list
      countryKey: '', //国家key

    }
  },
  created() {
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.inputFocus) {
        var sp = document.getElementById("localInputSeacrh");
        if (sp && !sp.contains(e.target)) {
          this.isShow = 3
        }
      }
    })


    // 筛选信息
    getCustomer().then((Customer) => {
      this.countryKey = Customer.WCAQueryCountryKey
      this.getAirport() //国家所有信息

    }).catch((error) => {

    })

    // console.log( ' sd '  + this.$route.path);
    // if(this.$route.path=='/'){
    this.getAirport() //国家所有信息
    // }




    setTimeout(() => {
      if (JSON.stringify(this.setData) !== "{}") {
        this.curList = this.setData
        var curText = `${this.curList.AirportCode3}(${this.curList.AirportNameEn})[${this.curList.CountryNameEn}]`
        this.inputText = curText;
        this.$emit('byCityValue', this.curList)
      }
    }, 500)
  },
  computed: { //计算属性函数
  },
  methods: {
    getAirport() {
      this.api.param = {}
      this.api.url = this.$api04 + "/Basics/api/Airport/QueryPort"
      post(this.api.url, this.api.param).then((res) => {
        if (res.Results) {
          if (res.Results.length > 0) {
            this.AllList = res.Results
            //console.log(this.countryKey)

            if (this.countryKey) {
              this.queryList = this.AllList.filter((item) => {
                if (String(item.Country_Key).toUpperCase() == this.countryKey) {
                  return item
                }
              })
            } else {
              this.queryList = this.AllList
            }
          }
        }
      });
    },
    // 聚焦
    focusInput: function (e) {
      this.isShow = 0
      this.inputFocus = true
      if (this.countryKey) {
        this.queryList = this.AllList.filter((item) => {
          if (String(item.Country_Key).toUpperCase() == this.countryKey) {
            return item
          }
        })
      } else {
        this.queryList = this.AllList
      }
      // if(this.countryKey) {
      //   this.queryList = this.AllList.filter((item)=>{
      //     if(item.key == this.countryKey) {
      //       return item
      //     }
      //   })
      // }
      this.$refs.ipt.select(); // or e.currentTarget.select();
    },

    //货物input输入框输入值
    getInputVal() {
      let inputVal = this.inputText
      let res = JSON.parse(JSON.stringify(this.AllList))
      if (inputVal) {
        // debugger
        //console.log(inputVal)
        this.isShow = 1
        res = res.filter((item) => {
          if (item.AirportNameEn.toUpperCase().indexOf(inputVal.toUpperCase()) !== -1 || item.AirportCode3.toUpperCase().indexOf(inputVal.toUpperCase()) !== -1) {
            return item
          }
        })
        let flag = false
        for (let index = 0; index < res.length; index++) {
          const ele = res[index];
          if (!flag) {
            if (ele.AirportCode3.toUpperCase() == inputVal.toUpperCase()) {
              res.splice(index, 1)
              res.unshift(ele)
              flag = true
            }
          }
        }
      }
      this.queryList = res
    },

    RecentShow() {
      if (this.isShow == 3) {
        this.isShow = 0
      }
    },

    //鼠标移入时清除键盘事件
    clearKeydown(index) {
      this.isIndex = index;
    },
    //鼠标移入时清除键盘事件
    clearKeydownQuery(index) {
      if (this.isShow == 0) {
        index = this.Recent.length + index
      }
      this.isIndex = index;
    },

    // 键盘方法
    keydown(e) {
      let showList = ''
      let allList = this.Recent.concat(this.queryList)
      if (this.isShow == 0) {
        showList = allList.length
      } else {
        showList = this.queryList.length
      }
      if (e.keyCode == 40) {//下键
        this.isIndex++;
        if (this.isIndex > showList - 1) {
          this.isIndex = 0;
        }
      } else if (e.keyCode == 38) {//上
        this.isIndex--;
        if (this.isIndex < 0) {
          this.isIndex = showList - 1;
        }
      } else if (e.keyCode == 13) {//回车
        if (this.isIndex >= 0) {
          if (this.isShow == 0) {
            this.curList = allList[this.isIndex]
          } else {
            this.curList = this.queryList[this.isIndex]
          }
          var curText = `${this.curList.AirportCode3}(${this.curList.AirportNameEn})[${this.curList.CountryNameEn}]`
          this.inputText = curText;
          this.isShow = 3
          this.disappear = false
          this.$emit('byCityValue', this.curList)
        }
        this.isIndex = -1;
      }
    },

    //列表点击事件
    getText(item) {
      this.curList = item
      var curText = `${this.curList.AirportCode3}(${this.curList.AirportNameEn})[${this.curList.CountryNameEn}]`
      this.inputText = curText; //text赋值
      this.isShow = 3 //关闭下拉框
      this.disappear = false
      this.$emit('byCityValue', this.curList)
      //传值到父组件
    },

    blurInput() {
      // 延迟等待getText事件
      this.inputFocus = false
      this.disappear = true
      setTimeout(() => {
        var curText = `${this.curList.AirportCode3}(${this.curList.AirportNameEn})[${this.curList.CountryNameEn}]`
        if (this.inputText != curText && this.disappear) {
          this.inputText = ''
          this.curList = ''
        }
        // this.isShow = 3
        this.$emit('byCityValue', this.curList)
      }, 200)
    },

    // +++++++++接口++++++++++

  },
}
</script>
<style lang="css" scoped>
.inputSearch {
  position: relative;
}
.inputSear {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 5px;
}
li {
  text-align: center;
}
.dataBox {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  position: absolute;
  top: 31px;
  left: 0px;
  z-index: 66;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dataBox ul li {
  cursor: pointer;
  color: #888;
  height: 30px;
}
.dataBox ul li:hover {
  background: #f5f7fa;
}
.dataBox ul li {
  padding: 0 5px;
}
.Recent {
  font-weight: 700;
  padding-left: 6px;
  line-height: 30px;
  background: #f5f5f5;
}
.isActive {
  background-color: #f5f7fa !important;
}
.es {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sepTipsMsg {
  color: #999;
  text-align: center;
}
.left {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  width: 60%;
  display: inline-block;
  text-align: left;
  vertical-align: text-bottom;
}
.right {
  font-size: 13px;
  height: 30px;
  line-height: 30px;
  text-align: right;
  width: 40%;
  display: inline-block;
  vertical-align: text-bottom;
}
.left_text {
  max-width: 200px;
}
.right_text {
  max-width: 100px;
  display: inline-block;
}
.fontZero {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/air/component/endInfoAdd.vue